module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av480-96fee63137e1c1e4b8e0ed9a5aa6d9a3.jpg";